import { render, staticRenderFns } from "./carpool-editDetail.vue?vue&type=template&id=253b889d"
import script from "./carpool-editDetail.vue?vue&type=script&lang=js"
export * from "./carpool-editDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports